import { axios } from '@Root/API'

export const deleteForm = id => {
  return axios.delete(`cognito-forms/${id}`)
}

